<template>
  <b-modal
    :visible="visible"
    @ok="deleteData"
    button-size="sm"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="registration-delete"
  >
    <template v-slot:modal-title>Anular programación</template>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div v-if="loadedData && registration.id !== null">
            <p>¿Está seguro de anular la programación?</p>
            <div class="row">
              <div class="col text-right"><b>Curso:</b></div>
              <div class="col">{{ registration.course_name }}</div>
            </div>
            <div class="row">
              <div class="col text-right"><b>Pensum:</b></div>
              <div class="col">{{ registration.syllabus_description }}</div>
            </div>
            <div class="row">
              <div class="col text-right"><b>Gestión:</b></div>
              <div class="col">{{ registration.courses_offered_year }}</div>
            </div>
            <div class="row">
              <div class="col text-right"><b>Periodo:</b></div>
              <div class="col">
                {{ registration.courses_offered_period | period }}.
              </div>
            </div>
            <div class="row">
              <div class="col text-right"><b>Tipo de Pension:</b></div>
              <div class="col">
                {{ registration.syllabus_tuition_name }}
              </div>
            </div>
          </div>
          <h4 class="text-center" v-else>Cargando ...</h4>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ ok }">
      <div class="col">
        <b-button
          size="sm"
          variant="secondary"
          class="float-left"
          @click="close"
        >
          <CIcon size="sm" name="cil-x-circle" /> Cancelar
        </b-button>

        <template v-if="registration.id !== null">
          <!-- si tiene ventas relacionadas -->
          <template v-if="registration.sale_id !== 0">
            <b-button
              size="sm"
              variant="danger"
              class="float-right"
              :disabled="!loadedData || loaderDelete"
              @click="deleteWithRefund()"
            >
              <span v-if="!loaderDelete">
                <CIcon size="sm" name="cil-x-circle" /> Anular y abonar a
                cuenta</span
              >
              <span v-if="loaderDelete">
                Cargando
                <CSpinner color="success" size="sm" /> </span
            ></b-button>
            <b-button
              size="sm"
              variant="warning"
              class="float-right mr-1"
              :disabled="!loadedData || loaderDelete"
              @click="deleteWithoutRefund()"
            >
              <span v-if="!loaderDelete">
                <CIcon size="sm" name="cil-trash" /> Anular</span
              >
              <span v-if="loaderDelete">
                Cargando
                <CSpinner color="success" size="sm" /> </span
            ></b-button>
          </template>
          <template v-else>
            <b-button
              size="sm"
              variant="danger"
              class="float-right"
              :disabled="!loadedData || loaderDelete"
              @click="ok()"
            >
              <span v-if="!loaderDelete">
                <CIcon size="sm" name="cil-trash" /> Anular</span
              >
              <span v-if="loaderDelete">
                Cargando
                <CSpinner color="success" size="sm" /> </span
            ></b-button>
          </template>
        </template>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BButton } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
// services
import Registrations from "@/plugins/services/registrations";

export default {
  name: "RegistrationDeleteModal",
  components: { BModal, BButton },
  props: {
    modShowDelregistration: { type: Boolean, required: true },
    registration_id: { type: Number, required: true },
  },
  data() {
    return {
      registration: {
        id: null,
      },
      loadedData: false,
      loaderDelete: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
    };
  },
  mounted() {
    this.loadedData = false;
    this.loaderDelete = false;
    this.getData();
  },
  computed: {
    visible() {
      return this.modShowDelregistration;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    getData() {
      Registrations.getOne(this.registration_id)
        .then((res) => {
          this.registration = res.data;
          this.loadedData = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Programación no encontrada.");
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
          this.loadedData = true;
        });
    },
    deleteData() {
      this.loaderDelete = false;
      Registrations.delete(this.registration_id)
        .then((res) => {
          this.loaderDelete = true;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.loaderDelete = true;
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", err.response.data.data);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
        });
    },
    deleteWithRefund() {
      this.loaderDelete = false;
      Registrations.refound(this.registration_id, {
        created_by: this.userAuth.username,
        user_id: this.userAuth.id,
      })
        .then((res) => {
          this.loaderDelete = true;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.loaderDelete = true;
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", err.response.data.data);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
        });
    },
    deleteWithoutRefund() {
      this.loaderDelete = false;
      Registrations.notRefound(this.registration_id, {
        created_by: this.userAuth.username,
        user_id: this.userAuth.id,
      })
        .then((res) => {
          this.loaderDelete = true;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("danger", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.loaderDelete = true;
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", err.response.data.data);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal(null, 500);
          }
        });
    },
    closeModal(data = null, status = 200) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("registrationDeleteModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
